import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SiteSlice } from './types';

const initialState: SiteSlice[] = [];

let nextEventId = 4;

export const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    loadSites: (state, action: PayloadAction<SiteSlice[]>) => {
      return action.payload;
    },
    
    toggleSiteStatusBoxDisplay: (state, action: PayloadAction<string>) => {
      const site = state.find(site => site.id == action.payload );
      site.status_box_display = !site.status_box_display;
    }
  }
});

export const { loadSites, toggleSiteStatusBoxDisplay } = sitesSlice.actions;

export const selectAllsites = (state: RootState) => state.sites;

export default sitesSlice.reducer;
